let CorrelationStackingPlayers = {
    CORRELATION_STACKING_RESTRICT_PLAYERS: 'CORRELATION_STACKING_RESTRICT_PLAYERS',
};

export default CorrelationStackingPlayers;
